import { render, staticRenderFns } from "./tipoControllo.vue?vue&type=template&id=426ee2c4&scoped=true&"
import script from "./tipoControllo.vue?vue&type=script&lang=js&"
export * from "./tipoControllo.vue?vue&type=script&lang=js&"
import style0 from "./tipoControllo.vue?vue&type=style&index=0&id=426ee2c4&scoped=true&lang=css&"
import style1 from "./tipoControllo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "426ee2c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VImg,VRow,VTextField})
